<template>
	<div>
		<fade-down-modal :show="showFeed" ref="box">
			<div class="setRemoteAssistance comMsgbox">
                <div class=header>
                    <header-tag :title="title"></header-tag>
                </div>
                <div class="content" style="overflow:hidden;">
                    <div class=suggestion>
                        你的建议对我们非常重要！一旦采纳，我们会通过你填写的邮箱或电话联系到你，而且当功能进入内测阶段时，还会邀请你参与内部测试。
                    </div>
                    <div class="commonLine" style="height:144px;">
                        <div class="left"><span style="veitical-align:top;">反馈内容：</span></div>
                        <div class="right">
                            <textarea name="" id="" cols="30" rows="10" placeholder="请畅所欲言，比如在什么情况下遇到什么问题，以及你期望怎样的解决方案。" v-model="issue"></textarea>
                        </div>
                    </div>
                    <div class="commonLine" style="height:40px;">
                        <div class="left"><span>联系邮箱：</span></div>
                        <div class="right">
                            <input type="text" placeholder="请填写邮箱地址，我们会进行回复（必填）" v-model="email">
                        </div>
                    </div>
                    <div class="commonLine callback" style="vertical-align:top;">
                        <div class="left"><span></span></div>
                        <div class="right" style="line-height: 30px;">
                            <input type="checkbox" v-model="acceptVisit" style="vertical-align:top;margin-top:6px;">
                            <span>是否愿意电话回访</span>
                        </div>
                    </div>
                </div>
                <img src="@/assets/img/icon/u207.png" style="display:block;margin-left:20px;" alt="">
                <div class="btn" style="margin-top:0">
                    <div class="left" style="margin-left:20px;color:#f00" v-text="wrong"></div>
                    <div class="right">
                        <a href="#" class=blue-btn @click="submit">递交</a>
                        <a href="#" class=default-btn @click="close">取消</a>
                    </div>
                </div>
			</div>
		</fade-down-modal>
	</div>
</template>

<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag';
import { advice } from '@/requests/user'
import FadeDownModal from '_c/modals/fadeDown';
import { Message } from 'view-design';
window.$msg = Message;
export default {
  name: 'barModals',
  components: {
    HeaderTag,
    FadeDownModal
  },
  props: {
    showFeed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '意见反馈',
      issue: '',
      email: '',
      acceptVisit: '',
      wrong: '',
      num: ''
    };
  },
  computed: {

  },
  watch: {

  },
  mounted() {

  },
  methods: {
    close() {
      this.$emit('sendShow', false)
    },
    async submit() {
      this.wrong = ''
      if (this.issue == '') {
        this.wrong = '内容不能为空'
        return false
      }
      if (this.email == '') {
        this.wrong = '邮箱不能为空'
        return false
      }
      if (this.acceptVisit == true) {
        this.num = 1
      } else {
        this.num = 0
      }
      let obj = {
        issue: this.issue,
        email: this.email,
        acceptVisit: this.num
      }
      let res = await advice(obj)
      if (res.code == 200) {
        this.close()
        window.$msg({
          type: 'success',
          message: res.msg,
          showClose: true,
        })
        this.issue = '',
        this.email = '',
        this.acceptVisit = false
      } else {
        this.wrong = res.msg
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/msgbox/_comMsg.scss";
@import "_style/_color.scss";
.setRemoteAssistance {
  height: 410px;
  .content{
      padding-left:0;
      .suggestion{
        margin: 0 auto;
        margin-top:10px;
        width: 500px;
        height: 50px;
        color: $orange;
        background-color: $orange-2;
        border:1px solid $orange-1;
        line-height:25px;
        text-align:left;
        padding:0 10px;
        margin-bottom:10px;
      }
      .commonLine{
          padding-left: 20px;
          width:480px;
          margin:auto;
          display: block;
          textarea{
            width: 300px;
            height: 120px;
            border:1px solid rgba(230,230,230,1);
            padding:5px;
            resize: none;
          }
      }
      .callback{
        height: 40px;
        margin-bottom: 0;
        .right{
            width:310px;
            text-align: left;
        }
        input{
            width:auto;
            height:auto;
            margin-right:5px;
            position: relative;
            top:2px;
        }
      }

  }
}
.content .commonLine .left span{
    vertical-align: top;
}
.content .commonLine .right input{
    vertical-align: top;
}
</style>

